// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-message[data-v-2a8f7fed]{position:relative;background:#f5f7f8 none repeat scroll 0 0;border-radius:20px;padding:3px}.location-message .map-link[data-v-2a8f7fed]{display:block;border-radius:17px;overflow:hidden;width:220px;height:150px;background-size:cover;background-position:50% 50%}", ""]);
// Exports
module.exports = exports;
